import React from 'react';
import { getImageUrl } from './types';

interface ProfileCardPhotoProps {
  photo: string | null;
  firstName: string;
  lastName: string;
  /**
   * @deprecated No longer drives the avatar color. Kept for prop-API stability;
   * the header bar is now the surface that reflects the Color Scheme picker.
   */
  colorScheme?: string;
  variant: 'preview' | 'full';
}

// Neutral slate gradient — avatar stays readable regardless of the chosen
// Color Scheme (which now drives the top bar) or HR brand colors.
const AVATAR_GRADIENT = 'from-slate-500 to-slate-700';

const ProfileCardPhoto: React.FC<ProfileCardPhotoProps> = ({
  photo,
  firstName,
  lastName,
  variant
}) => {
  const isPreview = variant === 'preview';
  const sizeClass = isPreview ? 'w-14 h-14' : 'w-32 h-32';
  const borderClass = isPreview ? 'border-2' : 'border-4';
  const textSizeClass = isPreview ? 'text-lg' : 'text-4xl';

  const initials = `${firstName?.[0] || 'U'}${lastName?.[0] || ''}`;

  return (
    <>
      {photo ? (
        <img
          src={getImageUrl(photo) || ''}
          alt={`${firstName} ${lastName}`}
          className={`${sizeClass} rounded-full ${borderClass} border-white shadow-lg object-cover bg-card`}
        />
      ) : (
        <div className={`${sizeClass} rounded-full ${borderClass} border-white shadow-lg flex items-center justify-center bg-gradient-to-br ${AVATAR_GRADIENT}`}>
          <span className={`${textSizeClass} font-bold text-white`}>
            {initials}
          </span>
        </div>
      )}
    </>
  );
};

export default ProfileCardPhoto;
